import ColumnText from "../molecules/ColumnText";
import { Fragment, MouseEventHandler } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";
import { DateTime } from "luxon";

export type TableListMaintenanceItemProps = {
  maintenanceItems: Array<any>;
  onClickEmpty: MouseEventHandler;
};

const TableListMaintenanceItem: React.FC<TableListMaintenanceItemProps> = ({
  maintenanceItems,
  onClickEmpty,
}) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {maintenanceItems?.length === 0 ? (
              <Empty texto="Tareas" onClick={onClickEmpty} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lead.views.task")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lead.views.date")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lead.views.assigned_to")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("maintenance.views.urgency")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("maintenance.views.status")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {maintenanceItems?.map((maintenanceItem) => (
                      <tr key={maintenanceItem.id}>
                        <ColumnText title={maintenanceItem.maintenance.task} />
                        <ColumnText
                          title={DateTime.fromFormat(
                            maintenanceItem?.maintenance?.date,
                            "yyyy-MM-dd"
                          ).toFormat("dd-MM-yyyy")}
                        />
                        <ColumnText
                          title={maintenanceItem?.maintenance?.assigned?.name}
                        />
                        <ColumnText
                          title={
                            <Fragment>
                              {maintenanceItem?.maintenance?.urgency == 1 &&
                                t("maintenance.views.urgency_low")}
                              {maintenanceItem?.maintenance?.urgency == 2 &&
                                t("maintenance.views.urgency_medium")}
                              {maintenanceItem?.maintenance?.urgency == 3 &&
                                t("maintenance.views.urgency_high")}
                            </Fragment>
                          }
                        />
                        <ColumnText
                          title={
                            <Fragment>
                              {maintenanceItem?.maintenance?.state == "0" &&
                                t("maintenance.views.status_pending")}
                              {maintenanceItem?.maintenance?.state == "1" &&
                                t("maintenance.views.status_complete")}
                            </Fragment>
                          }
                        />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListMaintenanceItem;
